export enum EnumQueryErrorTypes {
    FacebookAccessDenied = "facebook_access_denied",
    AppleAccessDenied = "apple_access_denied",
}

export enum EnumCookieErrorTypes {
    PasswordLinkExpired = "PasswordLinkExpired",
    General = "General",
}
